import colors from './colors';
import typeScale from './typeScale';

const theme = {
  colors,
  typeScale
};

export default theme;
